import { render, staticRenderFns } from "./daftar-pejabat.vue?vue&type=template&id=2005d25c&"
import script from "./daftar-pejabat.vue?vue&type=script&lang=js&"
export * from "./daftar-pejabat.vue?vue&type=script&lang=js&"
import style0 from "./daftar-pejabat.vue?vue&type=style&index=0&id=2005d25c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports